import React, { useState, useEffect } from 'react';
import './styles/index.scss';

import Header        from './components/Header';
import Ticker        from './components/Ticker';
import Hero          from './components/Hero';
import PriceCards    from './components/PriceCards';
import Insights      from './components/Insights';
import StationFinder       from './components/StationFinder';
import RegLookup           from './components/RegLookup';
import FuelGuide     from './components/FuelGuide';
import Alerts        from './components/Alerts';
// import Contribute    from './components/Contribute';
import Blog from './components/Blog';
import FAQ           from './components/FAQ';
import Footer        from './components/Footer';
import SubscribePopup from './components/SubscribePopup';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-S311NQ9JS4');

export default function App() {
  const [showPopup, setShowPopup]     = useState(false);
  const [searchState, setSearchState] = useState(null);

  // Track page view on load
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);

  // Show subscribe popup after 2.5s on first visit
  useEffect(() => {
    const seen = sessionStorage.getItem('ttt_popup_seen');
    if (!seen) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        ReactGA.event({ category: 'Popup', action: 'Subscribe Popup Shown' });
      }, 9500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handlePopupClose = () => {
    setShowPopup(false);
    sessionStorage.setItem('ttt_popup_seen', '1');
    ReactGA.event({ category: 'Popup', action: 'Subscribe Popup Dismissed' });
  };

  const handleSearch = (state) => {
    setSearchState(state);
    ReactGA.event({                                    
      category: 'Search',
      action: 'Station Search',
      label: `fuel:${state.fuelType} radius:${state.radius}mi`,
    });
  };

  return (
    <>
      {showPopup && (
        <SubscribePopup onClose={handlePopupClose} />
      )}

      <Header onSubscribeClick={() => setShowPopup(true)} />
      <Ticker />
      <Hero onSearch={handleSearch} />
      <PriceCards />
      <Insights />
      <StationFinder searchState={searchState} />
      <RegLookup />
      <FuelGuide />
      <Alerts />
      {/* <Contribute /> */}
      <Blog />
      <FAQ />
      <Footer />
    </>
  );
}
